module.exports = __webpack_public_path__ + "img/home_logo.6d3c41ff.png";